import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "../../SignUp/LeadSignup/LeadSignup.css";
// import Lottie from "react-lottie-player";
import { LottiePlayer as Lottie } from "Library/lottie-player";
import "../Login.css";

const lottieObj = {
  loop: true,
  autoplay: true,
  animationData: require("../../../Assets/lottie-jsons/signup_done.json"),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const SubscriptionUpdatePasswordSuccess = (props) => (
  <div className="lead-signup-form1 position-rel" align="center">
    <div className="sucessGif">
      <div>
        <Lottie options={lottieObj} height={200} width={200} />
      </div>
      <p align="center" className="sucessmessage padding-bottom-50">
        <FormattedMessage id="LbNewpassword" defaultMessage="New password updated successfully." />
        <Link to="/login">
          <span style={{ textDecoration: "underline" }}>SubscriptionLogin</span>
          {/* <FormattedMessage id="LkSubscriptionLogin" defaultMessage="SubscriptionLogin" /> */}
        </Link>
      </p>
    </div>
  </div>
);
export default SubscriptionUpdatePasswordSuccess;
